import { render, staticRenderFns } from "./ComprometimentoTimeLine.vue?vue&type=template&id=2a881c84&"
import script from "./ComprometimentoTimeLine.vue?vue&type=script&lang=js&"
export * from "./ComprometimentoTimeLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports